<div class="card-inner-main-div">
  <div class="card-main-title">
    <h4 class="card-title">{{ 'Particle Exposure' | translate }}<br>
    {{ 'Contribution By Task Group' | translate }}</h4>
  </div>

  @if (loading) {
    <app-widget-loader ></app-widget-loader>
  }
  @if (!loading) {
    @if (exposureByTaskGroupVm && exposureByTaskGroupVm.length) {
      @for (task of exposureByTaskGroupVm; track trackByIndex($index)) {
        <div (click)="toggleTaskGroupPopupFn(task)" style="cursor: pointer" class="text-progress-col">
          <label class="progress-text">{{task?.taskGroupName ? task?.taskGroupName+" " :
            ""}}({{task.changeAbsPercent}}% <img alt="" class="arrow-icon up-arrow"
          [src]="'assets/images/'+(task.changePercent > 0 ? 'red-up' : 'green-down')+'-arrow.svg'">)</label>
          <div  class="progress blue lighten-4 tooltipped cursor-pointer"
            data-position="top" data-tooltip="">
            <div class="determinate dark-blue-bg"
              [style]="{width: (task?.massContributionPercentAbs ? task?.massContributionPercentAbs : 0)+'%', animation: 'grow 2s'}">
              <span
              [ngClass]="{'zero': ($safeNavigationMigration(task?.massContributionPercentAbs) < 7)}">{{task?.massContributionPercent}}%</span>
            </div>
          </div>
        </div>
      }
      <!-- <div class="view-btn-div">
      <a class="view-all-btn purple-text">View All</a>
    </div> -->
  }
  @if (!(exposureByTaskGroupVm && exposureByTaskGroupVm.length)) {
    <div [innerHTML]="errorHtml"></div>
  }
}
</div>
